import Header from "./Header";
import Footer from "./Footer";
// import CTASection from "./CTASection";
import "../styles/header/header.css";
import "../styles/termOfUse/term.css";
export default function TermsOfUse() {
  return (
    <div className="main">
      <Header />
      <div className="terms-policy">
        <h1>
          Terms of Use
        </h1>
        <h3>General</h3>
        <p>
          Thank you for visiting{" "}
          <strong>  <a href="https://data.ai.gov.kh/">data.ai.gov.kh</a>{" "}</strong>

          (“website”). This platform is officially operated by the{" "}
          <strong>Ministry of Post and Telecommunications (MPTC)</strong>. By
          accessing or using this website, you agree to comply with and be bound
          by these Terms of Use. If you do not agree, please discontinue access
          and refrain from using this website.
        </p>
        <br />
        <p>
          MPTC reserves the right to amend or update these Terms of Use at any
          time without prior notice. Any changes will be effective once
          published on this website.
        </p>
        <h3>Copyrights and Intellectual Property</h3>
        <p>
          All materials, content, and intellectual property on this website are
          owned, licensed, or controlled by the Ministry of Post and
          Telecommunications (MPTC). No content including but not limited to
          text, images, software, and files may be reproduced, distributed,
          modified, or transmitted in any form without the prior written consent
          of MPTC.
        </p>
        <h3>Use of Upload Platform</h3>
        <p>
          Users must ensure that any files uploaded through this website:
        </p>
        <ul >
          <li>1. Do not contain viruses, malicious code, or harmful content.</li>
          <li>2. Do not infringe on the intellectual property rights of others.</li>
          <li>
            3. Do not contain unlawful, offensive, defamatory, or inappropriate
            material.
          </li>
          <li>
            4. Comply with all applicable laws and regulations of the Kingdom of
            Cambodia.
          </li>
        </ul>
        <p>
          The Ministry of Post and Telecommunications reserves the right to
          monitor, remove, or restrict access to any content that is deemed to
          violate these Terms of Use or national law.
        </p>
        <h3>Availability and Right of Access</h3>
        <p>
          The Ministry of Post and Telecommunications may suspend, modify, or
          discontinue the operation of this website at any time without prior
          notice. Access to this website may be restricted or denied to any
          person or IP address without prior notice and without providing
          reasons.
        </p>
        <p>
          The Ministry of Post and Telecommunications does not guarantee
          uninterrupted access, error-free operation, or the security of files
          uploaded by users. Users are responsible for keeping copies of their
          own files.
        </p>
        <h3>Links to Other Websites</h3>
        <p>
          This website may contain links to third-party websites. MPTC does not
          endorse, control, or take responsibility for the content,
          functionality, or security of those websites. Accessing third-party
          links is at your own risk.
        </p>
        <h3>Disclaimer and Limitation of Liability</h3>
        <p>
          The Ministry of Post and Telecommunications shall not be liable for
          any damages, loss of data, or other harm arising from:
        </p>
        <ul>
          <li>1. Use of or inability to use this website.</li>
          <li>2. Unauthorized access or alterations to your uploaded content.</li>
          <li>
            3. Reliance on information, services, or links provided by this
            website.
          </li>
        </ul>
        <h3>Creating a Link to This Website</h3>
        <p>
          Written permission from the Ministry of Post and Telecommunications is
          required before creating any link to this website or its content.
        </p>
        <h3>Governing Law</h3>
        <p>
          These Terms of Use shall be governed by and construed in accordance
          with the laws of the Kingdom of Cambodia.
        </p>
      </div>
      {/* <CTASection /> */}
      <Footer hideFooter={false} />
    </div >
  );
}
